export default {
  betaButtonTitle: {
    en: 'Go to App <small class="opacity-75">(beta)</small>',
  },
  new: {
    title: {
      en: 'Your App here',
    },
    text: {
      en: 'Want to start your own predictions platform? Apply and we’ll show you how.',
    },
    buttonTitle: {
      en: 'Launch On Azuro',
    },
  },
  disabled: {
    title: {
      en: 'Work in progress',
    },
    text: {
      en: 'Coming soon',
    },
  },
  tags: {
    dApp: {
      title: {
        en: 'dApp',
      },
    },
    predictionsApp: {
      title: {
        en: 'Predictions App',
      },
    },
    telegramBot: {
      title: {
        en: 'Telegram Bot',
      },
    },
    custodial: {
      title: {
        en: 'Custodial',
      },
      tooltip: {
        en: 'This application acts as an intermediary. When using it you do not interact with Azuro\'s smart contracts directly',
      },
    },
  },
}
